import React from "react";
import { Spinner, Modal, ModalBody } from "reactstrap";

export function ProgressModal(props) {
  const JSX = (
    <Modal isOpen={props.isOpen} centered={true} toggle={props.toggle}>
      <ModalBody>
        <div className="">
          <div className="d-flex align-items-center justify-content-center">
            <Spinner />
            <div className="mx-2"> {props.text} </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
  return JSX;
}
